import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from "../../../api.service";
import { NgForm } from '@angular/forms';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-screening-visits',
  templateUrl: './screening-visits.component.html',
  styleUrls: ['./screening-visits.component.scss']
})
export class ScreeningVisitsComponent implements OnInit {
  @ViewChild('form') form!: NgForm;
  // Properties to store route/query params
   folderName: any;
  formName: string | null = null;
 studyId: any;
 subjectId: any;
  queryParams: any = {};
  studyDetails: any;
  subjectName: any;
  // Flag to control data entry based on conditions
  dataEntryDisabled: boolean = false;
  

  // Your form data model
  formData = {
    consentSigned: '',
    language: '',
    consentDate: '',
    consentTime: '',
    vitalSigns: '',
    vitalSignsComments: '',
    physicalExam: '',
    physicalExamComments: '',
    pregnancyStatus: '',
    idrsAssessment: '',
    idrsAssessmentComments: '',
    gender: '',
    dateOfBirth: '',
    age: '',
    weight: null,  // Change to number
    height: null,  // Change to number
    waistCircumference: null,  // Change to number
    bmi: null, 
    medicalHistory: '',
    medicalConditions: [] as string[],
    labInvestigation:'',  // ✅ Add this
    labInvestigationComments:'' , // ✅ Add this
    sampleCollectionDate: '',
  sampleCollectionTime: '',
    enrolled: '',
    screeningFailure: [],
    reason: {  // ✅ Change from string to an object
      inclusionCriteria: '',
      exclusionCriteria: '',
      withdrawal: '',
       // Add this line
    } ,
    priorMedication: '',
    investigatorSignature: '', // Add this line
  screeningDate: '', // Add this line  
  screeningDate1:'',
  lmpDate: '',     // Date of Last Menstrual Period
  uptDone: '',     // Urine Pregnancy Test done (Yes/No)
  uptResult: '',
  };
  criteria = {
    age: '',
    riskCategory: '',
    hba1c: '',
    bmi: '',
    informedConsent: '',
    severeDisease: '',
    pregnancy: '',
    medicationImpact: '',
    inclusionCriteria: '', // ✅ Add this
    exclusionCriteria: '', // ✅ Add this
    withdrawal: ''         // ✅ Add this
  };

  //query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: { threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] }[] = [
  {  threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  // query code end

  //edit thing
  isConsentDisabled: boolean=false;
  // isConsent2Disabled: boolean=false;
  isLanguageDisabled: boolean = false;
  isDatePickerDisabled: boolean = false;
  isScreeningDisabled: boolean = false;
  isDatePickerDisabled3: boolean = false;
  isScreeningDateDisabled: boolean = false;
  isTimePickerDisabled: boolean = false;
  isAgeDisabled: boolean = false;
  isGenderDisabled: boolean = false;
  isReasonModalOpen: boolean = false;
   isWeightDisabled: boolean = false;
  isHeightDisabled: boolean = false;
  isCircumferenceDisabled: boolean = false;
  isBmiDisabled: boolean = false;
  isR1Disabled: boolean = false;
  isR2Disabled: boolean = false;
  isR3Disabled: boolean = false;
  isR4Disabled: boolean = false;
  //isR5Disabled: boolean = false;
  //isR6Disabled: boolean = false;
  isR7Disabled: boolean = false;
  isR8Disabled: boolean = false;
  isDateUtpDisabled: boolean = false;
  isSelectUtpDisabled: boolean = false;
  isSelect2UtpDisabled: boolean = false;
  isR9Disabled: boolean = false;
  isR10Disabled: boolean = false;
  isR11Disabled: boolean = false;
  isR12Disabled: boolean = false;
  isLabDDisabled: boolean = false;
  isLabTDisabled: boolean = false;
  isR13Disabled: boolean = false;
  isR14Disabled: boolean = false;
  isEligibilitySelectDisabled: boolean = false;
  isSignDisabled: boolean = false;
  isEndDDisabled: boolean = false;
  isInc1Disabled: boolean = false;
  isInc2Disabled: boolean = false;
  isInc3Disabled: boolean = false;
  isInc4Disabled: boolean = false;
  isInc5Disabled: boolean = false;
  isExc1Disabled: boolean = false;
  isExc2Disabled: boolean = false;
  isExc3Disabled: boolean = false;

  editReason: string = '';

  currentYear = new Date().getFullYear();
  screeningDateMin: string;
  // Mapping for each form: question text to formData field
  private questionMapping: { [key: string]: { question: string, field: string }[] } = {
    'Screening Visit Date': [
    { question: '1. Date of Screening Visit:', field: 'screeningDate1' }
  ],
    'informed-consent': [
      { question: 'Did the Subject read, understand, and sign the Informed Consent form', field: 'consentSigned' },
      { question: 'Language of Informed Consent Form given to the patient:', field: 'language' },
      { question: 'Date of Signing', field: 'consentDate' },
      { question: 'Time of Signing', field: 'consentTime' }
    ],
    'demography': [
      { question: '1. Gender:', field: 'gender' },
      { question: '2. Date of Birth (DD/MMM/YYYY):', field: 'dateOfBirth' },
      { question: '3. Age (Years & Months):', field: 'age' }
    ],
    'anthropometric-data': [
      { question: '1. Weight (kg):', field: 'weight' },
      { question: '2. Height (m):', field: 'height' },
      { question: '3. Waist Circumference (cm) (Part of IDRS Assessment):', field: 'waistCircumference' },
      { question: '4. Body Mass Index (BMI):', field: 'bmi' }
    ],
    'medical-history': [
    { question: 'Does the subject have any relevant medical history', field: 'medicalHistory' },
  ],
  'prior-medication': [
    { question: 'Any relevant medications taken by subject within the last 1 month up to screening visit', field: 'priorMedication' },
    { question: 'List of Prior Medications:', field: 'priorMedications' } // Array of objects (medicationName, dosage, frequency, duration)
  ],
  'vital-signs': [
    { question: 'Was vital signs evaluation performed', field: 'vitalSigns' }
  ],

 'physical-exam': [
    { question: 'Was physical and systemic examination performed', field: 'physicalExam' }
  ],
  'pregnancy-declaration': [
  { question: 'Date of Last Menstrual Period (LMP)', field: 'lmpDate' },
  { question: 'Was Urine Pregnancy Test (UPT) done', field: 'uptDone' },
  { question: 'UPT Result', field: 'uptResult' }
  ],
  'idrs': [
    { question: 'Was IDRS Assessment performed', field: 'idrsAssessment' }
  ],
  'laboratory-investigation': [
    { question: 'Was Laboratory Investigation performed', field: 'labInvestigation' },
    { question: 'Date of Sample Collection', field: 'sampleCollectionDate' },
  { question: 'Time of Sample Collection', field: 'sampleCollectionTime' }
  ],
  'inclusion-exclusion': [
    { question: '1. Age is between 35 years and 60 years (both ages included):', field: 'age' },
    { question: '2. Moderate or High-Risk category according to Indian Diabetes Risk Score:', field: 'riskCategory' },
    { question: '3. HbA1c value in the range 5.7% - 6.4%:', field: 'hba1c' },
    { question: '4. BMI indicating Overweight or Obese:', field: 'bmi' },
    { question: '5. The subject is capable to give informed consent:', field: 'informedConsent' },
    { question: '1. History of severe disease (Hypertension, renal disease, etc.):', field: 'severeDisease' },
    { question: '2. Pregnant or lactating woman:', field: 'pregnancy' },
    { question: '3. Any medication that may impact the study:', field: 'medicationImpact' }
  ],
  'eligibility-assessment': [
    { question: 'Has the subject enrolled in the study', field: 'eligibilityAssessment' }
],

  
  'end-of-screening': [
    { question: 'Principal Investigator’s Signature:', field: 'investigatorSignature' },
    { question: 'Date:', field: 'screeningDate' }
  ]
  
  };
  studyCode: any;
  studyName: any;
  siteLocation: any;
  maxDate: string;
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;


//review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

  constructor( private apiService: ApiService,private route: ActivatedRoute, private router: Router,private commonService: CommonService) {}

  ngOnInit(): void {

     // Example: Console log user data from cookies
  const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);

  const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);

    console.log('ngOnInit Executed');
    const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = today.getFullYear();
  this.todayDate = `${year}-${month}-${day}`; // Format for input type="date"
   
  // Assuming you get informedConsentDate in the response
  //this.informedConsentDate = "2025-02-01"; // You can replace this with dynamic data

  // Set the min date to informedConsentDate
  //this.screeningMinDate = this.informedConsentDate;
  
  // Initialize informedConsentDate and screeningMinDate
  this.informedConsentDate = ''; // Start with an empty value
  this.screeningMinDate = ''; // Same for screeningMinDate

    this.route.params.subscribe(params => {
      this.folderName = params['foldername']; // Ensure correct casing (foldername)
      this.formName = params['formName'];
      console.log('Route Params:', params);
  
      // Call API only after setting both route and query params
      this.checkAndCallApi();
    });
  
    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
      console.log('Query Params:', queryParams);
  
      // Call API only after setting both route and query params
      this.checkAndCallApi();
    });
  }
    //  document.addEventListener('click', () => {
    //   this.isOptionsModalOpen = false;
    // });

  checkAndCallApi() {
    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      console.log("Calling API getFormData...");
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            // Ensure response.data is an array before mapping
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }
            this.mapStudyDetails(response.studyDetails);
            
            // Dynamically update informedConsentDate from the response
            if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;  // Set min date
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }

          // Store the gender from the response
          this.gender = response.gender;
          console.log("gender:",this.gender);
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
       // const fieldName = '2. Date of Study Completion:';
      const fieldName = this.fieldLabel || 'Unknown Field';
  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });


    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
  }


 addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}







  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
       
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
  if (selected.type === 'fieldHistory') {
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Field History for:', fieldName);
    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Field History Data:', response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
  }

}
  
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
  this.showReviewModal = true;
   const fieldName = this.fieldLabel || 'Unknown Field';
  console.log('Opening Review Modal - Fetching Field History for:', fieldName);

  this.apiService.getInsertHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Field History Data (from review modal):', response);
      this.fieldHistoryData = response.data || [];

      // Initialize default review flags
      let latestReview = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      // Sort descending by updated_at to get the latest ones first
      const sortedData = [...this.fieldHistoryData].sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());

      const flagsFound = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      for (const entry of sortedData) {
        if (!entry.review_status) continue;

        try {
          const parsed = JSON.parse(entry.review_status);

          // For each reviewer type, only update if not already found (i.e., get the latest one)
          if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
            latestReview.dataMonitor = parsed.dataMonitor;
            flagsFound.dataMonitor = true;
          }

          if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
            latestReview.monitor = parsed.monitor;
            flagsFound.monitor = true;
          }

          if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
            latestReview.pi = parsed.pi;
            flagsFound.pi = true;
          }

          // If all found, stop early
          if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
            break;
          }

        } catch (err) {
          console.error("Error parsing review_status JSON:", err);
        }
      }

      this.reviewOptions = latestReview;
      console.log("✅ Final reviewOptions applied:", this.reviewOptions);
    },

    error: (error) => {
      console.error('Error fetching field history data from review modal:', error);
    }
  });
}

closeReviewModal() {
  this.showReviewModal = false;
}

openOptionsModal(event: MouseEvent, target: EventTarget | null) {
  event.stopPropagation();
  this.isOptionsModalOpen = true;

  // Traverse to the closest parent with `data-label`
  const icon = target as HTMLElement;
  const fieldGroup = icon.closest('.form-group');

 if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Dynamically captured label:', this.fieldLabel);
  }
}

openModal() {
  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'

  // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
  const fieldName = this.fieldLabel || 'Unknown Field';
 console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this

  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item => 
  typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
);

const query = {
  threadId: entry.threadId || 'no-thread',
  text: this.getInitialQueryText(auditTrail) || '',
  isClosed: isClosed,
  auditTrail: auditTrail
};

         

          return query;
        });
      } else {
        // Fallback for empty or invalid data
        this.queries = Array(3).fill(null).map(() => ({
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });
}

getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}
submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];

  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }

reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI

  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}





  // Function to map study details
mapStudyDetails(studyDetails: any): void {
  if (studyDetails) {
    // Check if studyDetails has the expected properties
    this.studyCode = studyDetails.study_code ?? 'N/A';  // Default to 'N/A' if study_code is undefined
    this.studyName = studyDetails.study_name ?? 'Unknown Study';  // Default to 'Unknown Study' if study_name is undefined
    this.siteLocation = studyDetails.site_location ?? 'Unknown Location';  // Default to 'Unknown Location' if site_location is undefined
    this.subjectName = this.subjectId;  // Mapping subjectId to subjectName
    
    console.log("Mapped Study Details:", {
      studyCode: this.studyCode,
      studyName: this.studyName,
      siteLocation: this.siteLocation,
      subjectName: this.subjectName,
    });
  } else {
    console.warn('Study details are missing or undefined.');
  }
}
isConsentData = false;
hasLanguageData=false;
hasDateOfSignData=false;
hasTimeOfSignData=false;
hasDateOfScreeningData=false;
hasGenderData=false;
hasDOBData=false;
hasAgeData=false;
hasWeightData=false;
hasHeightData=false;
hasWaistData=false;
hasBMIData=false;
hasMedicalHistoryData=false;
hasPriorMedicationData =false;
hasVitalSignData=false;
hasPhysicalExamData=false;
hasLMPData=false;
hasUPTDoneData=false;
hasUPTResultData=false;
hasIDRSData=false;
hasLabData=false;
hasDateOfSampleData=false;
hasTimeOfSampleData=false;
hasInc1Data=false;
hasInc2Data=false;
hasInc3Data=false;
hasInc4Data=false;
hasInc5Data=false;
hasExc1Data=false;
hasExc2Data=false;
hasExc3Data=false;
hasEligibilityData=false;
hasPrincipalSignData=false;
hasEndDData=false;


  mapFormData(data: any[]): void {
  this.isConsentData = false;
  this.hasLanguageData=false;
  this.hasDateOfSignData=false;
  this.hasTimeOfSignData=false;
  this.hasDateOfScreeningData=false;
  this.hasGenderData=false;
  this.hasDOBData=false;
  this.hasAgeData=false;
  this.hasWeightData=false;
  this.hasHeightData=false;
  this.hasWaistData=false;
  this.hasBMIData=false;
  this.hasMedicalHistoryData=false;
  this.hasPriorMedicationData =false;
  this.hasVitalSignData=false;
  this.hasPhysicalExamData=false;
  this.hasLMPData=false;
  this.hasUPTDoneData=false;
  this.hasUPTResultData=false;
this.hasIDRSData=false;
this.hasLabData=false;
this.hasDateOfSampleData=false;
this.hasTimeOfSampleData=false;
this.hasInc1Data=false;
this.hasInc2Data=false;
this.hasInc3Data=false;
this.hasInc4Data=false;
this.hasInc4Data=false;
this.hasExc1Data=false;
this.hasExc2Data=false;
this.hasExc3Data=false;
 this.hasEligibilityData=false;
 this.hasPrincipalSignData=false;
 this.hasEndDData=false;


  

    data.forEach(item => {
      const fieldName = item.field_name?.trim(); // Trim whitespace to prevent errors
      const fieldValue = item.value;
  
      // Map checkbox values
    if (fieldName === 'reviewedByDataMonitor') this.reviewOptions.dataMonitor = fieldValue === 'true';
    if (fieldName === 'reviewedByMonitor') this.reviewOptions.monitor = fieldValue === 'true';
    if (fieldName === 'reviewedByPI') this.reviewOptions.pi = fieldValue === 'true';

      switch (fieldName) {
     // **Demography Form**
        case '1. Gender:':
          this.formData.gender = fieldValue;
          this.isGenderDisabled = !!fieldValue;
          this.hasGenderData=!!fieldValue;
          break;
        case '2. Date of Birth (DD/MMM/YYYY):':
          this.formData.dateOfBirth = fieldValue;
          this.updateAge(); // Call function to update age based on DOB
          this.isDatePickerDisabled3 = !!fieldValue;
          this.hasDOBData=!!fieldValue;
          break;
        case '3. Age (Years & Months):':
          this.formData.age = fieldValue;
          this.isAgeDisabled = !!fieldValue;
          this.hasAgeData=!!fieldValue;
          break;
  
        // **Informed Consent Form**
        case 'Did the Subject read, understand, and sign the Informed Consent form':
          this.formData.consentSigned = fieldValue;
          this.isConsentDisabled = !!fieldValue;
          // this.isConsent2Disabled = !!fieldValue;
          break;
        case 'Language of Informed Consent Form given to the patient:':
          this.formData.language = fieldValue;
          this.isLanguageDisabled = !!fieldValue;
          this.hasLanguageData=!!fieldValue;
          break;
        case 'Date of Signing':
          this.formData.consentDate = fieldValue;
          this.isDatePickerDisabled = !!fieldValue;
          this.hasDateOfSignData=!!fieldValue;
          break;
            case 'Time of Signing':
              this.formData.consentTime = this.convertTo24HourFormat(fieldValue);
              this.isTimePickerDisabled = !!fieldValue;
              this.hasTimeOfSignData=!!fieldValue;
              break;
          
        case '1. Date of Screening Visit:':
            this.formData.screeningDate1 = fieldValue;
            this.isScreeningDisabled = !!fieldValue;
            this.hasDateOfScreeningData=!!fieldValue;
            break;
        // **Anthropometric Data Form**
        case '1. Weight (kg):':
          this.formData.weight = parseFloat(fieldValue) || 0;
          this.calculateBMI();
          this.isWeightDisabled = !!fieldValue;
          this.hasWeightData=!!fieldValue;
          break;
        case '2. Height (m):':
          this.formData.height = parseFloat(fieldValue) || 0;
          this.calculateBMI();
          this.isHeightDisabled = !!fieldValue;
          this.hasHeightData=!!fieldValue;
          break;
        case '3. Waist Circumference (cm) (Part of IDRS Assessment):':
          this.formData.waistCircumference = parseFloat(fieldValue) || 0;
          this.isCircumferenceDisabled = !!fieldValue;
          this.hasWaistData=!!fieldValue;
          break;
        case '4. Body Mass Index (BMI):':
          this.formData.bmi = parseFloat(fieldValue) || 0;
          this.isBmiDisabled = !!fieldValue;
          this.hasBMIData=!!fieldValue;
          break;
  
        // **Medical History Form**
        case 'Does the subject have any relevant medical history':
          this.formData.medicalHistory = fieldValue;
          this.isR2Disabled = !!fieldValue;
          this.isR1Disabled  = !!fieldValue;
          this.hasMedicalHistoryData=!!fieldValue;
          break;
        case 'List of Medical Conditions:':
          this.formData.medicalConditions = fieldValue ? JSON.parse(fieldValue) : [];
          break;
  
        // **Prior Medication Form**
        case 'Any relevant medications taken by subject within the last 1 month up to screening visit':
          this.formData.priorMedication = fieldValue;
          this.isR3Disabled = !!fieldValue;
          this.isR4Disabled  = !!fieldValue;
          this.hasPriorMedicationData =!!fieldValue;
          break;
  
        // **Vital Signs Form**
        case 'Was vital signs evaluation performed':
          this.formData.vitalSigns = fieldValue;
          this.hasVitalSignData=!!fieldValue;
          // this.isR5Disabled = !!fieldValue;
          //this.isR6Disabled  = !!fieldValue;
          if (fieldValue === 'no') {
            this.formData.vitalSignsComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
  
       
  
        // **Physical and Systemic Examination Form**
      case 'Was physical and systemic examination performed':
        this.formData.physicalExam = fieldValue; 
         this.isR7Disabled = !!fieldValue;
         this.hasPhysicalExamData=!!fieldValue;
          this.isR8Disabled  = !!fieldValue;// Map 'yes' or 'no' value to formData
        if (fieldValue === 'no') {
          this.formData.physicalExamComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
        }
        break;
      
  
        // **Pregnancy Declaration Form**
        // case '1. Ask the subject “Are you currently pregnant?':
        //   this.formData.pregnancyStatus = fieldValue; // Map 'Yes', 'No', or 'N/A' value to formData
        //   break;
        case 'Date of Last Menstrual Period (LMP)':
  this.formData.lmpDate = fieldValue; // Store LMP Date
         this.isDateUtpDisabled = !!fieldValue;
         this.hasLMPData=!!fieldValue;
  break;

case 'Was Urine Pregnancy Test (UPT) done':
  this.formData.uptDone = fieldValue; // Store UPT Done (YES/NO)
         this.isSelectUtpDisabled = !!fieldValue;
         this.hasUPTDoneData=!!fieldValue;
  break;

case 'UPT Result':
  this.formData.uptResult = fieldValue; // Store UPT Result (Positive/Negative)
         this.isSelect2UtpDisabled = !!fieldValue;
         this.hasUPTResultData=!!fieldValue;
  break;
  
        // **IDRS Form**
        case 'Was IDRS Assessment performed':
          this.formData.idrsAssessment = fieldValue;
         this.isR9Disabled = !!fieldValue;
         this.isR10Disabled = !!fieldValue;
         this.hasIDRSData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.idrsAssessmentComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
        
  
        // **Laboratory Investigation Form**
        case 'Was Laboratory Investigation performed':
          this.formData.labInvestigation = fieldValue;
          this.isR11Disabled = !!fieldValue;
         this.isR12Disabled = !!fieldValue;
         this.hasLabData=!!fieldValue;
          if (fieldValue === 'no') {
            this.formData.labInvestigationComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;
          case 'Date of Sample Collection':
            this.formData.sampleCollectionDate = fieldValue;
            this.isLabDDisabled = !!fieldValue;
            this.hasDateOfSampleData=!!fieldValue;
            break;
          
          case 'Time of Sample Collection':
            this.formData.sampleCollectionTime = fieldValue;
            this.isLabTDisabled = !!fieldValue;
            this.hasTimeOfSampleData=!!fieldValue;
            break;
          
  
        // **Inclusion Criteria**
        case '1. Age is between 35 years and 60 years (both ages included):':
          this.criteria.age = fieldValue;
          this.isInc1Disabled = !!fieldValue;
          this.hasInc1Data=!!fieldValue;
          break;
        case '2. Moderate or High-Risk category according to Indian Diabetes Risk Score:':
          this.criteria.riskCategory = fieldValue;
          this.isInc2Disabled = !!fieldValue;
          this.hasInc2Data=!!fieldValue;
          break;
        case '3. HbA1c value in the range 5.7% - 6.4%:':
          this.criteria.hba1c = fieldValue;
          this.isInc3Disabled = !!fieldValue;
          this.hasInc3Data=!!fieldValue;
          break;
        case '4. BMI indicating Overweight or Obese:':
          this.criteria.bmi = fieldValue;
          this.isInc4Disabled = !!fieldValue;
          this.hasInc4Data=!!fieldValue;
          break;
        case '5. The subject is capable to give informed consent:':
          this.criteria.informedConsent = fieldValue;
          this.isInc5Disabled = !!fieldValue;
          this.hasInc5Data=!!fieldValue;
          break;
  
        // **Exclusion Criteria**
        case '1. History of severe disease (Hypertension, renal disease, etc.):':
          this.criteria.severeDisease = fieldValue;
          this.isExc1Disabled = !!fieldValue;
          this.hasExc1Data=!!fieldValue;
          break;
        case '2. Pregnant or lactating woman:':
          this.criteria.pregnancy = fieldValue;
          this.isExc2Disabled = !!fieldValue;
          this.hasExc2Data=!!fieldValue;
          break;
        case '3. Any medication that may impact the study:':
          this.criteria.medicationImpact = fieldValue; 
          this.isExc3Disabled = !!fieldValue;
          this.hasExc3Data=!!fieldValue;
          break;
  //eligibility assesment form 
          case 'Has the subject enrolled in the study':
            this.formData.enrolled = fieldValue;
            this.isR13Disabled = !!fieldValue;
            this.isR14Disabled = !!fieldValue;
            this.isEligibilitySelectDisabled = !!fieldValue;
            this.hasEligibilityData=!!fieldValue;
            break;
          
  
        // **End of Screening Visit Form**
        case "Principal Investigator’s Signature:":
          this.formData.investigatorSignature = fieldValue;
            this.isSignDisabled = !!fieldValue;
            this.hasPrincipalSignData=!!fieldValue;
          break;
        case "Date:":
          this.formData.screeningDate = fieldValue;
            this.isEndDDisabled= !!fieldValue;
            this.hasEndDData=!!fieldValue;
          break;
        //
        case "Has the subject enrolled in the study?":
    this.formData.enrolled = fieldValue;
    if (fieldValue === 'no') {
        // Ensure `sub_data` exists and clean up the format properly
        this.formData.screeningFailure = item.sub_data ? item.sub_data.replace(/^"(.*)"$/, '$1') : null;
    } 
    console.log("Mapped Screening Failure:", this.formData.screeningFailure);
    break;

      
        

  
        default:
          console.warn(`No mapping found for field: ${fieldName}`);
          break;
      }
    });


    console.log('Final Form Data:', this.formData);
    
  }
  editStudy() {
  // Open edit reason modal only if field already has a value
  if (this.fieldLabel === 'Did the Subject read, understand, and sign the Informed Consent form' && this.formData.consentSigned) {
    this.isReasonModalOpen = true;
  } else if (this.fieldLabel === 'Language of Informed Consent Form given to the patient:' && this.formData.language) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === 'Date of Signing' && this.formData.consentDate) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === 'Time of Signing' && this.formData.consentTime) {
    this.isReasonModalOpen = true;
  } 
else if (this.fieldLabel === '1. Date of Screening Visit:' && this.formData.screeningDate1) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '1. Gender:' && this.formData.gender) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '2. Date of Birth (DD/MMM/YYYY):' && this.formData.dateOfBirth) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '3. Age (Years & Months):' && this.formData.age) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '1. Weight (kg):' && this.formData.weight) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '2. Height (m):' && this.formData.height) {
    this.isReasonModalOpen = true;
  } 
  else if (this.fieldLabel === '3. Waist Circumference (cm) (Part of IDRS Assessment):' && this.formData.waistCircumference) {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === '4. Body Mass Index (BMI):' && this.formData.bmi) {
    this.isReasonModalOpen = true;
  } 
    else if (this.fieldLabel === 'Does the subject have any relevant medical history' && this.formData.medicalHistory) {
    this.isReasonModalOpen = true;
  } 
   else if (this.fieldLabel === 'Any relevant medications taken by subject within the last 1 month up to screening visit' && this.formData.priorMedication) {
    this.isReasonModalOpen = true;
  }
    /* else if (this.fieldLabel === 'Was vital signs evaluation performed' && this.formData.vitalSigns) {
    this.isReasonModalOpen = true;
  }*/
  else if (this.fieldLabel === 'Was physical and systemic examination performed' && this.formData.physicalExam) {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === 'Date of Last Menstrual Period (LMP)' && this.formData.lmpDate) {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === 'Was Urine Pregnancy Test (UPT) done' && this.formData.uptDone) {
    this.isReasonModalOpen = true;
  }
  else if (this.fieldLabel === 'UPT Result' && this.formData.uptResult) {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === 'Was IDRS Assessment performed' && this.formData.idrsAssessment) {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === 'Was Laboratory Investigation performed' && this.formData.labInvestigation) {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === 'Date of Sample Collection' && this.formData.sampleCollectionDate) {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === 'Time of Sample Collection' && this.formData.sampleCollectionTime) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Has the subject enrolled in the study' && this.formData.enrolled) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Principal Investigator’s Signature:' && this.formData.investigatorSignature) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === 'Date:' && this.formData.screeningDate) {
    this.isReasonModalOpen = true;
  }

      else if (this.fieldLabel === '1. Age is between 35 years and 60 years (both ages included):' && this.criteria.age) {
    this.isReasonModalOpen = true;
  }
    else if (this.fieldLabel === '2. Moderate or High-Risk category according to Indian Diabetes Risk Score:' && this.criteria.riskCategory) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === '3. HbA1c value in the range 5.7% - 6.4%:' && this.criteria.hba1c) {
    this.isReasonModalOpen = true;
  }
     else if (this.fieldLabel === '5. The subject is capable to give informed consent:' && this.criteria.informedConsent) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === '4. BMI indicating Overweight or Obese:' && this.criteria.bmi) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === '1. History of severe disease (Hypertension, renal disease, etc.):' && this.criteria.severeDisease) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === '2. Pregnant or lactating woman:' && this.criteria.pregnancy) {
    this.isReasonModalOpen = true;
  }
   else if (this.fieldLabel === '3. Any medication that may impact the study:' && this.criteria.medicationImpact) {
    this.isReasonModalOpen = true;
  }
  else {
    // First time - no need to ask
    if (this.fieldLabel === 'Did the Subject read, understand, and sign the Informed Consent') {
      this.isConsentDisabled = false;
      // this.isConsent2Disabled = false;
    } else if (this.fieldLabel === 'Language of Informed Consent Form given to the patient:') {
      this.isLanguageDisabled = false;
    }
    else if (this.fieldLabel === 'Date of Signing') {
      this.isDatePickerDisabled = false;
    }
    else if (this.fieldLabel === 'Time of Signing') {
      this.isTimePickerDisabled = false;
    }
     else if (this.fieldLabel === '1. Date of Screening Visit:') {
      this.isScreeningDisabled = false;
    }
     else if (this.fieldLabel === '1. Gender:') {
      this.isGenderDisabled = false;
    }
     else if (this.fieldLabel === '2. Date of Birth (DD/MMM/YYYY):') {
      this.isDatePickerDisabled3 = false;
    }
     else if (this.fieldLabel === '3. Age (Years & Months):') {
      this.isAgeDisabled = false;
    }
       else if (this.fieldLabel === '1. Weight (kg):') {
      this.isWeightDisabled = false;
    }
      else if (this.fieldLabel === '2. Height (m):') {
      this.isHeightDisabled = false;
    }
      else if (this.fieldLabel === '3. Waist Circumference (cm) (Part of IDRS Assessment):') {
      this.isCircumferenceDisabled = false;
    }
      else if (this.fieldLabel === '4. Body Mass Index (BMI):') {
      this.isBmiDisabled = false;
    }
     else if (this.fieldLabel === 'Does the subject have any relevant medical history') {
      this.isR1Disabled = false;
      this.isR2Disabled = false;
    }
      else if (this.fieldLabel === 'Any relevant medications taken by subject within the last 1 month up to screening visit') {
      this.isR3Disabled = false;
      this.isR4Disabled = false;
    }
    /* else if (this.fieldLabel === 'Was vital signs evaluation performed') {
      this.isR5Disabled = false;
      this.isR6Disabled = false;
    }*/
      else if (this.fieldLabel === 'Was physical and systemic examination performed') {
      this.isR7Disabled = false;
      this.isR8Disabled = false;
    }
     else if (this.fieldLabel === 'Date of Last Menstrual Period (LMP)') {
      this.isDateUtpDisabled = false;
    }
     else if (this.fieldLabel === 'Was Urine Pregnancy Test (UPT) done') {
      this.isSelectUtpDisabled = false;
    }
     else if (this.fieldLabel === 'UPT Result') {
      this.isSelect2UtpDisabled = false;
    }
      else if (this.fieldLabel === 'Was IDRS Assessment performed') {
      this.isR9Disabled = false;
      this.isR10Disabled = false;
    }
       else if (this.fieldLabel === 'Was Laboratory Investigation performed') {
      this.isR11Disabled = false;
      this.isR12Disabled = false;
    }
       else if (this.fieldLabel === 'Date of Sample Collection') {
      this.isLabDDisabled = false;
    }
       else if (this.fieldLabel === 'Time of Sample Collection') {
      this.isLabTDisabled = false;
    }
     else if (this.fieldLabel === 'Has the subject enrolled in the study') {
      this.isEligibilitySelectDisabled = false;
      this.isR13Disabled = false;
      this.isR14Disabled = false;
    }
       else if (this.fieldLabel === 'Principal Investigator’s Signature:') {
      this.isSignDisabled = false;
    }
       else if (this.fieldLabel === 'Date:') {
      this.isEndDDisabled = false;
    }
    //
         else if (this.fieldLabel === '1. Age is between 35 years and 60 years (both ages included):') {
      this.isInc1Disabled = false;
    }
       else if (this.fieldLabel === '2. Moderate or High-Risk category according to Indian Diabetes Risk Score:') {
      this.isInc2Disabled = false;
    }
         else if (this.fieldLabel === '3. HbA1c value in the range 5.7% - 6.4%:') {
      this.isInc3Disabled = false;
    }
       else if (this.fieldLabel === '4. BMI indicating Overweight or Obese:') {
      this.isInc4Disabled = false;
    }
         else if (this.fieldLabel === '5. The subject is capable to give informed consent:') {
      this.isInc5Disabled = false;
    }
        else if (this.fieldLabel === '1. History of severe disease (Hypertension, renal disease, etc.):') {
      this.isExc1Disabled = false;
    }
        else if (this.fieldLabel === '2. Pregnant or lactating woman:') {
      this.isExc2Disabled = false;
    }
        else if (this.fieldLabel === '3. Any medication that may impact the study:') {
      this.isExc3Disabled = false;
    }
     
  }
}
confirmEditReason() {
  if (!this.editReason.trim()) {
    alert('Please enter a reason before proceeding.');
    return;
  }

 if (this.fieldLabel === 'Did the Subject read, understand, and sign the Informed Consent form') {
  this.isConsentDisabled = false;
}
 else if (this.fieldLabel === 'Language of Informed Consent Form given to the patient:') {
    this.isLanguageDisabled = false;
  }
else if (this.fieldLabel === 'Date of Signing') {
    this.isDatePickerDisabled = false;
  }
  else if (this.fieldLabel === 'Time of Signing') {
    this.isTimePickerDisabled = false;
  }
  else if (this.fieldLabel === '1. Date of Screening Visit:') {
    this.isScreeningDisabled = false;
  }
  else if (this.fieldLabel === '1. Gender:') {
    this.isGenderDisabled  = false;
  }
  else if (this.fieldLabel === '2. Date of Birth (DD/MMM/YYYY):') {
    this.isDatePickerDisabled3 = false;
  }
  else if (this.fieldLabel === '3. Age (Years & Months):') {
    this.isAgeDisabled = false;
  }
   else if (this.fieldLabel === '1. Weight (kg):') {
    this.isWeightDisabled = false;
  }
   else if (this.fieldLabel === '2. Height (m):') {
    this.isHeightDisabled = false;
  }
   else if (this.fieldLabel === '3. Waist Circumference (cm) (Part of IDRS Assessment):') {
    this.isCircumferenceDisabled = false;
  }
   else if (this.fieldLabel === '4. Body Mass Index (BMI):') {
    this.isBmiDisabled = false;
  }
   else if (this.fieldLabel === 'Does the subject have any relevant medical history') {
    this.isR1Disabled = false;
    this.isR2Disabled = false;
  }
   else if (this.fieldLabel === 'Any relevant medications taken by subject within the last 1 month up to screening visit') {
    this.isR3Disabled = false;
    this.isR4Disabled = false;
  }
   /* else if (this.fieldLabel === 'Was vital signs evaluation performed') {
    this.isR5Disabled = false;
    this.isR6Disabled = false;
  }*/
  else if (this.fieldLabel === 'Was physical and systemic examination performed') {
    this.isR7Disabled = false;
    this.isR8Disabled = false;
  }
   else if (this.fieldLabel === 'Date of Last Menstrual Period (LMP)') {
    this.isDateUtpDisabled = false;
  }
   else if (this.fieldLabel === 'Was Urine Pregnancy Test (UPT) done') {
    this.isSelectUtpDisabled = false;
  }
   else if (this.fieldLabel === 'UPT Result') {
    this.isSelect2UtpDisabled = false;
  }
  else if (this.fieldLabel === 'Was IDRS Assessment performed') {
    this.isR9Disabled = false;
    this.isR10Disabled = false;
  }
   else if (this.fieldLabel === 'Was Laboratory Investigation performed') {
    this.isR11Disabled = false;
    this.isR12Disabled = false;
  }
   else if (this.fieldLabel === 'Date of Sample Collection') {
    this.isLabDDisabled = false;
  }
   else if (this.fieldLabel === 'Time of Sample Collection') {
    this.isLabTDisabled = false;
  }
   else if (this.fieldLabel === 'Has the subject enrolled in the study') {
    this.isR13Disabled  = false;
    this.isR14Disabled  = false;
    this.isEligibilitySelectDisabled   = false; 
  }
     else if (this.fieldLabel === 'Principal Investigator’s Signature:') {
    this.isSignDisabled = false;
  }
   else if (this.fieldLabel === 'Date:') {
    this.isEndDDisabled = false;
  }
    else if (this.fieldLabel === '1. Age is between 35 years and 60 years (both ages included):') {
    this.isInc1Disabled = false;
  }
   else if (this.fieldLabel === '2. Moderate or High-Risk category according to Indian Diabetes Risk Score:') {
    this.isInc2Disabled = false;
  }
     else if (this.fieldLabel === '3. HbA1c value in the range 5.7% - 6.4%:') {
    this.isInc3Disabled = false;
  }
   else if (this.fieldLabel === '4. BMI indicating Overweight or Obese:') {
    this.isInc4Disabled = false;
  }
     else if (this.fieldLabel === '5. The subject is capable to give informed consent:') {
    this.isInc5Disabled = false;
  }
  //
       else if (this.fieldLabel === '1. History of severe disease (Hypertension, renal disease, etc.):') {
    this.isExc1Disabled = false;
  }
    else if (this.fieldLabel === '2. Pregnant or lactating woman:') {
    this.isExc2Disabled = false;
  }
     else if (this.fieldLabel === '3. Any medication that may impact the study:') {
    this.isExc3Disabled = false;
  }
     
  
  this.isReasonModalOpen = false;
}
cancelEditReason() {
  this.isReasonModalOpen = false;
  this.editReason = '';
}

  formatTimeTo24Hour(time: string): string {
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`; // Ensures it's always in 24-hour format
}


handleUptResultChange(): void {
  if (this.formData.uptResult === 'Positive') {
    alert('As the UPT test is positive, kindly exclude the patient from the study.');
  }
}
convertTo24HourFormat(time: string): string {
  // Check if the time contains AM or PM (i.e., is in 12-hour format)
  if (time.toLowerCase().includes('am') || time.toLowerCase().includes('pm')) {
      let [timePart, modifier] = time.split(' '); // Split time and AM/PM
      let [hours, minutes] = timePart.split(':').map(Number);

      if (modifier.toLowerCase() === 'pm' && hours !== 12) {
          hours += 12;
      } else if (modifier.toLowerCase() === 'am' && hours === 12) {
          hours = 0;
      }

      // Ensure two-digit format (e.g., 09:05 instead of 9:5)
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  // If the time is already in 24-hour format, return it as is
  return time;
}
  
  
  
  updateScreeningFailure(event: any) {
    const reason = event.target.value;
    if (event.target.checked) {
      // Add the reason to the array if checked
      this.formData.screeningFailure.push(reason);
    } else {
      // Remove the reason from the array if unchecked
      const index = this.formData.screeningFailure.indexOf(reason);
      if (index > -1) {
        this.formData.screeningFailure.splice(index, 1);
      }
    }
  }
  validateForm() {
    const weightPattern = /^\d{3}\.\d{2}$/;
    const heightPattern = /^\d{2}\.\d{2}$/;
    const waistPattern = /^\d{3}\.\d{2}$/;
  
    const { weight, height, waistCircumference } = this.formData;
  
    // Only validate fields if they are not empty
    if (weight && !weightPattern.test(weight)) {
      alert("Invalid weight format. Please enter in 000.00 kg format.");
      return;
    }
  
    if (height && !heightPattern.test(height)) {
      alert("Invalid height format. Please enter in 00.00 m format.");
      return;
    }
  
    if (waistCircumference && !waistPattern.test(waistCircumference)) {
      alert("Invalid waist circumference format. Please enter in 000.00 cm format.");
      return;
    }
  
    // If all are valid, submit the form
    this.submitForm();
  }

  navigateToPriorMedication(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/prior-medication/prior-medication-log'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  

  navigateToVitalSigns(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/vital-signs/vital-signs'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  
  navigateToLaboratory(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/laboratory-investigation-log/laboratory-investigation-log'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  
  
  navigateToIDRS(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/idrs/idrs-form-log'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  navigateToPhysicalSystemic(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/physical-systemic/physical-systemic'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
}

  
  
  submitForm() {
    if (this.isModalOpen) {
      return; // Skip if modal is open (indicating query submission)
    }
   // if(this.showReviewModal){
     // return;
    //}
    /*if (this.form.invalid) {
      return; // Prevent submission if the form is invalid
    }*/
    if (this.formData.vitalSigns === 'no' && (!this.formData.vitalSignsComments || this.formData.vitalSignsComments.trim() === '')) {
      alert('Comments are required when "No" is selected.');
      return;
    }
    if (this.formData.physicalExam === 'no' && (!this.formData.physicalExamComments || this.formData.physicalExamComments.trim() === '')) {
      alert('Comments are required when "No" is selected.');
      return;
    }
    if (this.formData.labInvestigation === 'no' && (!this.formData.labInvestigationComments || this.formData.labInvestigationComments.trim() === '')) {
      alert('Comments are required when "No" is selected.');
      return;
    }
    if (this.formData.idrsAssessment === 'no' && (!this.formData.idrsAssessmentComments || this.formData.idrsAssessmentComments.trim() === '')) {
      alert('Comments are required when "No" is selected.');
      return;
    }
      if(this.isReasonModalOpen){
      return;
    }
    const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  
    let questionAnswers: { [key: string]: any } = {};

    if (this.formName && this.questionMapping[this.formName]) {
        this.questionMapping[this.formName].forEach(mapping => {
          let fieldKey = mapping.question; // Use only the question text


            if (mapping.field === 'vitalSigns') {
                if (this.formData.vitalSigns === 'no' && this.formData.vitalSignsComments) {
                    questionAnswers[fieldKey] = {
                        answer: "no",
                        reviewStatus: { ...this.reviewOptions },
                        value: this.formData.vitalSignsComments
                    };
                } else {
                    questionAnswers[fieldKey] = this.formData.vitalSigns;
                }
            } else if (mapping.field === 'physicalExam') {
                if (this.formData.physicalExam === 'no' && this.formData.physicalExamComments) {
                    questionAnswers[fieldKey] = {
                        answer: "no",
                        reviewStatus: { ...this.reviewOptions },
                        value: this.formData.physicalExamComments
                    };
                } else {
                    questionAnswers[fieldKey] = this.formData.physicalExam;
                }
            } else if (mapping.field === 'pregnancyStatus') {
                questionAnswers[fieldKey] = this.formData.pregnancyStatus;
            } else if (mapping.field === 'idrsAssessment') {
                if (this.formData.idrsAssessment === 'no' && this.formData.idrsAssessmentComments) {
                    questionAnswers[fieldKey] = {
                        answer: "no",
                        reviewStatus: { ...this.reviewOptions },
                        value: this.formData.idrsAssessmentComments
                    };
                } else {
                    questionAnswers[fieldKey] = this.formData.idrsAssessment;
                }
            } else if (mapping.field === 'labInvestigation') {
                if (this.formData.labInvestigation === 'no' && this.formData.labInvestigationComments) {
                    questionAnswers[fieldKey] = {
                        answer: "no",
                        reviewStatus: { ...this.reviewOptions },
                        value: this.formData.labInvestigationComments
                    };
                } else {
                    questionAnswers[fieldKey] = this.formData.labInvestigation;
                }
            } else if (this.formName === 'inclusion-exclusion') {
              if (mapping.field === 'age') {
                  questionAnswers[fieldKey] = this.criteria.age;
              } else if (mapping.field === 'riskCategory') {
                  questionAnswers[fieldKey] = this.criteria.riskCategory;
              } else if (mapping.field === 'hba1c') {
                  questionAnswers[fieldKey] = this.criteria.hba1c;
              } else if (mapping.field === 'bmi') {
                  questionAnswers[fieldKey] = this.criteria.bmi;
              } /*else if (mapping.field === 'informedConsent') {
                  questionAnswers[fieldKey] = this.criteria.informedConsent;
              } */else if (mapping.field === 'severeDisease') {
                  questionAnswers[fieldKey] = this.criteria.severeDisease;
              } else if (mapping.field === 'pregnancy') {
                  questionAnswers[fieldKey] = this.criteria.pregnancy;
              } else if (mapping.field === 'medicationImpact') {
                  questionAnswers[fieldKey] = this.criteria.medicationImpact;
              } else if (mapping.field === 'informedConsent') {
                console.log('Edit Reason for field:', this.editReason);
    questionAnswers[fieldKey] = {
      answer: this.formData[mapping.field],
      reviewStatus: { ...this.reviewOptions },
      editReason: this.editReason || '' // Include edit reason if provided
              }
          } 
           else if (mapping.field === 'screeningDate1') {
                console.log('Edit Reason for field:', this.editReason);
    questionAnswers[fieldKey] = {
      answer: this.formData[mapping.field],
      reviewStatus: { ...this.reviewOptions },
      editReason: this.editReason || '' // Include edit reason if provided
              }
          } 
           else if (mapping.field === 'screeningDate1') {
                console.log('Edit Reason for field:', this.editReason);
    questionAnswers[fieldKey] = {
      answer: this.formData[mapping.field],
      reviewStatus: { ...this.reviewOptions },
      editReason: this.editReason || '' // Include edit reason if provided
              }
          } 
          }
          else if (mapping.field === 'eligibilityAssessment') {
            questionAnswers[fieldKey] = this.formData.enrolled === 'no' && this.formData.screeningFailure
                ? { answer: "no", reviewStatus: { ...this.reviewOptions },value: this.formData.screeningFailure }
                : this.formData.enrolled;
        } 

          
          else {
            console.log('Edit Reason for field 1:', this.editReason);
                questionAnswers[fieldKey] = {
  answer: this.formData[mapping.field],
  editReason: this.editReason || '',
  reviewStatus: { ...this.reviewOptions }
};
                
            }
        });
    }

    const submittedData = {
      //folderName: this.folderName,
        folderName: "screening-visits",
        formName: this.formName,
        studyId: this.studyId,
        subjectId: this.subjectId,
        user: fullName, 
        ...questionAnswers
    };

    console.log("Form Submitted:", submittedData);

    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
          console.log("Response from API:", response);
          alert("Form Submitted Successfully!");
          // ✅ Disable calendar and clear edit reason after successful submission
      this.isDatePickerDisabled = true;
      this.isScreeningDisabled = true;
      this.isTimePickerDisabled = true;
      this.isLanguageDisabled = true;
      this.isConsentDisabled = true;
      // this.isConsent2Disabled = true;
      this.isGenderDisabled = true;
      this.isAgeDisabled = true;
      this.isDatePickerDisabled3 = true;
      this.isHeightDisabled = true;
      this.isWeightDisabled = true;
      this.isCircumferenceDisabled = true;
      this.isBmiDisabled = true;
      this.isR1Disabled=true;
      this.isR2Disabled=true;
      this.isR3Disabled=true;
      this.isR4Disabled=true;
      //this.isR5Disabled=true;
      //this.isR6Disabled=true;
      this.isR7Disabled=true;
      this.isR8Disabled=true;
      this.isDateUtpDisabled=true;
      this.isSelectUtpDisabled=true;
      this.isSelect2UtpDisabled=true;
      this.isR9Disabled=true;
      this.isR10Disabled=true;
      this.isR11Disabled=true;
      this.isR12Disabled=true;
      this.isLabDDisabled=true;
      this.isLabTDisabled=true;
      this.isR13Disabled=true;
      this.isR14Disabled=true;
      this.isEligibilitySelectDisabled =true;
      this.isSignDisabled =true;
      this.isEndDDisabled =true;
      this.isInc1Disabled=true;
      this.isInc2Disabled=true;
      this.isInc3Disabled=true;
      this.isInc4Disabled=true;
      this.isExc1Disabled=true;
      this.isExc2Disabled=true;
      this.isExc3Disabled=true;

      this.editReason = '';
      },
      error: (error) => {
          console.error("Error submitting form:", error);
          alert("Error submitting form. Please try again.");
      }
  });
  
  
}
  insertFormData(submittedData: { folderName: string | null; formName: string | null; studyId: string | null; subjectId: string | null; }) {
    throw new Error('Method not implemented.');
  }




  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }

  createField() {
    alert("Create Field Clicked!");
  }

  checkVitalSigns() {
    if (this.formData.vitalSigns === 'no') {
      this.formData.vitalSignsComments = '';
    }
  }

  checkPhysicalExam() {
    if (this.formData.physicalExam === 'no') {
      this.formData.physicalExamComments = '';
    }
  }

  checkPregnancyStatus() {
    this.dataEntryDisabled = this.formData.pregnancyStatus === 'Yes';
  }

  checkIDRSAssessment() {
    if (this.formData.idrsAssessment === 'no') {
      this.formData.idrsAssessmentComments = '';
    }
  }

  // updateAge() {
  //   if (this.formData.dateOfBirth) {
  //     const dob = new Date(this.formData.dateOfBirth);
  //     const today = new Date();
  //     let age = today.getFullYear() - dob.getFullYear();
  //     const monthDiff = today.getMonth() - dob.getMonth();
  //     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
  //       age--;
  //     }
  //     this.formData.age = age.toString();
  //   }
  // }
  updateAge() {
    if (this.formData.dateOfBirth) {
      const dob = new Date(this.formData.dateOfBirth);
      const today = new Date();
  
      let years = today.getFullYear() - dob.getFullYear();
      let months = today.getMonth() - dob.getMonth();
      const dayDiff = today.getDate() - dob.getDate();
  
      if (months < 0 || (months === 0 && dayDiff < 0)) {
        years--;
        months += 12;
      }
  
      if (dayDiff < 0) {
        months--;
        if (months < 0) {
          months += 12;
          years--;
        }
      }
  
      this.formData.age = `${years} Years ${months} Months`;
    }
  }
  

  calculateBMI(): void {
    const weight = this.formData.weight;
    const height = this.formData.height;
  
    if (weight > 0 && height > 0) {
      this.formData.bmi = parseFloat((weight / (height * height)).toFixed(1));
    } else {
      this.formData.bmi = 0; // Default to 0 if values are invalid
    }
  }
  

  checkMedicalHistory() {
    if (this.formData.medicalHistory === 'no') {
      this.formData.medicalConditions = [];
    }
  }

  addMedicalCondition(condition: string) {
    if (condition) {
      this.formData.medicalConditions.push(condition);
    }
  }

  removeMedicalCondition(index: number) {
    this.formData.medicalConditions.splice(index, 1);
  }
  
  //new + import line to allow. closing of panel
@HostListener('document:click', ['$event'])
onClickOutside(event: MouseEvent) {
  const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
  if (!clickedInside) {
    this.isOptionsModalOpen = false;
  }
}

  
}


